<template>
  <div :class="['product-list', { loading, 'product-list--one-column': viewOneColumn }]">
    <div
      v-if="products?.length"
      class="product-list__wrapper"
      :class="{'product-list__wrapper_no-filters': noFilters}"
    >
      <ProductListItem
        v-for="(product, index) in products"
        :key="product.productId"
        :product="product"
        :img-load-lazy="index > 9"
      />
    </div>

    <ProductListEmptyBlock v-else />

    <ButtonBlackBig
      v-if="page < totalPages"
      class="mt-10"
      @click="emit('click-more')"
    >
      {{ $t('common.showMore') }}
    </ButtonBlackBig>

    <UIPagination
      v-if="totalPages > 1"
      class="mt-10"
      :total-pages="totalPages"
      :current-page="page"
      @go-to-page="goToPage($event)"
    />
  </div>
</template>

<script lang="ts" setup>
import ProductListItem from '~/components/catalog/ProductListItem.vue';
import ButtonBlackBig from '~/components/ui/ButtonBlackBig.vue';
import UIPagination from '~/components/ui/UIPagination.vue';
import ProductListEmptyBlock from '~/components/catalog/ProductListEmptyBlock.vue';
import { ProductDTORes } from '~/restAPI/data-contracts';

const props = defineProps<{
  products?: ProductDTORes[]
  totalPages?: number
  page: number
  loading?: boolean,
  viewOneColumn?: boolean,
  noFilters?: boolean,
}>();

const emit = defineEmits<{
  (e: 'click-more'): void
  (e: 'click-page', value: number): void
}>();

const { isDesktop } = useUiBreakpoints();

function goToPage(page: number) {
  emit('click-page', page);

  const el: HTMLElement | null = document.querySelector('.product-list');

  if (!el) return;

  window.scrollTo({
    top: el.offsetTop - 16 - (isDesktop.value ? 190 : 40),
    behavior: 'smooth',
  });
}
</script>

<style scoped lang="scss">
@tailwind components;

@layer components {
  .product-list {
    @apply flex flex-col items-center mt-4 pb-10;

    &.loading {
      @apply pointer-events-none opacity-40;
    }

    &__wrapper {
      @apply w-full grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 pt-4;

      &_no-filters {
        @apply lg:grid-cols-4 xl:grid-cols-5;
      }
    }

    &--one-column {
      .product-list__wrapper {
        grid-template-columns: unset;
      }
    }
  }
}
</style>
